import API from 'utils/api';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/remolques/';
const files = [
  'comprobante_de_domicilio',
  'factura_del_vehiculo',
  'pedimento_del_vehiculo',
];
const headers = { 'Content-Type': 'multipart/form-data' };

/**
 * GET Remolques
 * @param {object} params
 * @returns {Promise<object>}
 */
export const getRemolques = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return { ...response.data, results: formatReceived(response.data.results) };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Remolque
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getRemolque = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Remolque
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRemolque = async (values) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: true,
    });
    const response = await API.post(baseURI, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Remolque
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRemolque = async (id, values, clean = true) => {
  try {
    const config = hasFiles(values, files) ? { headers } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues, config);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Remolque
 * @param {number} id
 * @param {number} idVehiculo
 * @returns {Promise<object|boolean>}
 */
export const deleteRemolque = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Para obtener los cargos de un vehiculo
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getRemolqueCaja = async (params = null) => {
  try {
    const response = await API.get('recaudacion/remolques-caja', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
